import React from 'react'
import List from '../../List/List'
//import I18n from "i18n-js/index.js.erb"
import clsx from "clsx"

export default class HousekeepingLogHousekeepingTypePresenter extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.activeTab == "housekeeping_type",
      'tab-pane': true
    });
    var inputs = []
    for(var i = 0, ilen = this.props.all_housekeeping_types.length; i < ilen; i++) {
      if (this.props.housekeeping_type && this.props.all_housekeeping_types[i].id == this.props.housekeeping_type.id) {
        inputs.push(this.props.all_housekeeping_types[i])
        break;
      }
    }

    return (
      <div className={tabClasses} id="housekeeping_types">
        <div className="col-md-12 form-group">
          {inputs[0] && inputs.length
            ? <List
              header_primary="code"
              header_secondary="name"
              items={inputs}
              display_column_primary="code"
              display_column_secondary="name"
              show_status={true}
            />
            : <div className="no-records">
              <span className="none">{I18n.t('none')}</span>
            </div>
          }
        </div>
      </div>
    )
  }
}
